import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import {
	Pagination,
	PaginationContent,
	PaginationEllipsis,
	PaginationItem,
	PaginationLink,
	PaginationNext,
	PaginationPrevious,
} from "../../../components/ui/pagination";

const EventReportPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-4xl font-bold text-center mb-12">活動報告</h1>

				<div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
					{/* 活動報告カード */}
					<article className="bg-white rounded-lg shadow-md overflow-hidden">
						<img
							src="/images/event-sample1.jpg"
							alt="もくもく会の様子"
							className="w-full h-48 object-cover"
						/>
						<div className="p-6">
							<time className="text-sm text-gray-500">2024年3月15日</time>
							<h2 className="text-xl font-semibold mt-2 mb-4">
								3月度もくもく会を開催しました
							</h2>
							<p className="text-gray-600 mb-4">
								今回は10名の参加者が集まり、それぞれの課題に取り組みました。
								プログラミング学習やデザインの練習など、様々な分野での学習が行われました。
							</p>
							<div className="flex flex-wrap gap-2">
								<span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
									もくもく会
								</span>
								<span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
									プログラミング
								</span>
							</div>
						</div>
					</article>

					{/* 他の活動報告カード */}
					<article className="bg-white rounded-lg shadow-md overflow-hidden">
						<img
							src="/images/event-sample2.jpg"
							alt="勉強会の様子"
							className="w-full h-48 object-cover"
						/>
						<div className="p-6">
							<time className="text-sm text-gray-500">2024年3月1日</time>
							<h2 className="text-xl font-semibold mt-2 mb-4">
								Web開発基礎講座を実施
							</h2>
							<p className="text-gray-600 mb-4">
								HTMLとCSSの基礎を学ぶ勉強会を開催しました。
								参加者からは「分かりやすかった」「実践的で良かった」との声をいただきました。
							</p>
							<div className="flex flex-wrap gap-2">
								<span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm">
									勉強会
								</span>
								<span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
									Web開発
								</span>
							</div>
						</div>
					</article>
				</div>

				{/* ページネーションを修正 */}
				<div className="mt-12 flex justify-center">
					<Pagination>
						<PaginationContent>
							<PaginationItem>
								<PaginationPrevious href="#" />
							</PaginationItem>
							<PaginationItem>
								<PaginationLink href="#" isActive>
									1
								</PaginationLink>
							</PaginationItem>
							<PaginationItem>
								<PaginationLink href="#">2</PaginationLink>
							</PaginationItem>
							<PaginationItem>
								<PaginationLink href="#">3</PaginationLink>
							</PaginationItem>
							<PaginationItem>
								<PaginationEllipsis />
							</PaginationItem>
							<PaginationItem>
								<PaginationNext href="#" />
							</PaginationItem>
						</PaginationContent>
					</Pagination>
				</div>
			</div>
		</Layout>
	);
};

export default EventReportPage;
